import { styled } from '@mui/material/styles';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { PORTAL_ACCENT } from './portalTheme';

export const PortalTableHead = styled(TableHead)(({ theme }) => ({
  '& .MuiTableCell-head': {
    fontWeight: 700,
    fontSize: '0.75rem',
    letterSpacing: '0.02em',
    color: theme.portal.textMuted,
    backgroundColor: theme.portal.tableHeaderBg,
    borderBottom: `1px solid ${theme.portal.inputBorder}`,
    padding: '10px 12px',
    whiteSpace: 'nowrap',
  },
}));

export const PortalTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${theme.portal.border}`,
  padding: '10px 12px',
  fontSize: '0.875rem',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
}));

export const PortalTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.portal.tableRowHover,
  },
  '&:last-child td': {
    borderBottom: 0,
  },
}));

export { PORTAL_ACCENT as PORTAL_TABLE_NAME_HOVER };
